// extracted by mini-css-extract-plugin
export var goldKicker = "KickerComponent-module--goldKicker--7454a";
export var kickerStyling = "KickerComponent-module--kickerStyling--291a2";